import { isApiErrorDto } from "../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../common/errors/isFetchBaseQueryError";

export const CHANGED_ELSEWHERE = "zz_MarketDialogueApiErrorCodeChangedElsewhere";

export const isChangedElsewhere = (e: unknown) =>
  isFetchBaseQueryError(e) && e.status === 409 && isApiErrorDto(e.data) && e.data.errorCode === CHANGED_ELSEWHERE;

export type ChangedElsewhereRefusal = "save" | "publish";
